import { createI18n } from "vue-i18n";

const defaultLanguage = localStorage.getItem("lang") || "pt";
const storedTranslations = localStorage.getItem("translations");
const messages = storedTranslations ? JSON.parse(storedTranslations) : {};

const i18n = createI18n({
  legacy: false,
  locale: getDefaultLanguage(),
  fallbackLocale: defaultLanguage, // 当前语言翻译缺失时显示的语言
  messages,
  missing: (locale, key) => {
    // 屏蔽所有缺失提示
    return key // 直接返回 key，不打 log
  },
  // Vue I18n v9 里用这个关闭警告
  missingWarn: false,
  fallbackWarn: false,
});


export const $t = i18n.global.t as any;
// export const $t = (title:any) =>{
//   return  '$' + title
// };
export const $locale = i18n.global.locale;

function getDefaultLanguage()  {
  const locales = Object.keys(messages);
  // 1. 优先从 cookies 中取得语言
  const lang = localStorage.getItem("lang") || "pt";
  console.log('lang-------------lang: ' + lang);
  localStorage.setItem("lang", lang);
  const chosenLanguage = lang
  if (chosenLanguage && locales.includes(chosenLanguage)) return chosenLanguage;

  // 2. 其次从浏览器中取得默认语言
  const browserLanguage = navigator.language.toLowerCase() ;
  if (locales.includes(browserLanguage)) return browserLanguage;
  // 3. 最后默认语言
  return defaultLanguage;
}

export function setLocale(locale:any) {
  i18n.global.locale.value = locale;
}

export default i18n;
